const type_buttons = document.querySelectorAll(".bundle_type_button");
// Static mode: the pre-set bundle type covers every product of this template
const allTypesButton = document.querySelector(
  ".bundle_type_button[data-type-all]",
);
const selected_products = JSON.parse(
  // @ts-ignore
  document.querySelector("script[data-bundle-products]").textContent,
);

const style_buttons_wrapper = document.getElementById("style_buttons");
const size_buttons_wrapper = document.getElementById("size_buttons");
const color_buttons_wrapper = document.getElementById("color_buttons");

// @ts-ignore
const currentProductId = // @ts-ignore
  document.querySelector(".bundle_picker_wrapper").dataset.currentProductId;
// @ts-ignore
const currentProduct = selected_products.find(
  // @ts-ignore
  (p) => String(p.id) === currentProductId,
);

// Color values are compared in lowercase so "Black" and "black " match
// @ts-ignore
const normalizeColor = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

// @ts-ignore
const getProductsByType = (type) =>
  // @ts-ignore
  selected_products.filter((p) => p.type === type);

// @ts-ignore
const selectType = (button) => {
  type_buttons.forEach((b) => {
    b.classList.remove("active-type-button");
  });
  button.classList.add("active-type-button");
};

// Trio / 3-style bundles, matched on product type or title
// @ts-ignore
const isTrioProduct = (product) =>
  /trio|3\s*styles?/i.test(`${product.type || ""} ${product.title || ""}`);

// @ts-ignore
const renderStyleButtons = (selectedTypeProducts) => {
  // In the pre-set bundle trios go to the end, and sold-out styles go last within each group;
  // sort is stable, so the original order is kept otherwise
  const sortedProducts = [...selectedTypeProducts].sort(
    // @ts-ignore
    (a, b) =>
      (allTypesButton
        ? Number(isTrioProduct(a)) - Number(isTrioProduct(b))
        : 0) || Number(b.available) - Number(a.available),
  );

  // @ts-ignore
  style_buttons_wrapper.innerHTML = sortedProducts
    .map(
      // @ts-ignore
      (p) => `
        <div class="style_button${p.available ? "" : " is-sold-out"}" data-product-id="${p.id}">
          ${p.swatches
            .map(
              // @ts-ignore
              (swatch_background) => `
                <span
                  class="style_item_swatch"
                  ${swatch_background ? `style="--swatch-background: ${swatch_background}"` : ""}
                ></span>
              `,
            )
            .join("")}
          <p class="style-button-text">${p.title}</p>
        </div>
      `,
    )
    .join("");
};

// @ts-ignore
const selectStyle = (productId) => {
  // @ts-ignore
  style_buttons_wrapper.querySelectorAll(".style_button").forEach((b) => {
    b.classList.remove("is-active-style");
  });
  // @ts-ignore
  const styleButton = style_buttons_wrapper.querySelector(
    `.style_button[data-product-id="${productId}"]`,
  );
  if (styleButton) styleButton.classList.add("is-active-style");
};

/** @type {string | null} */
let selectedColor = null;
/** @type {string | null} */
let selectedSize = null;

// @ts-ignore
const getColorBundle = (product, color) =>
  // @ts-ignore
  (product.colorBundles || []).find(
    // @ts-ignore
    (bundle) => normalizeColor(bundle.color) === normalizeColor(color),
  );

// Resolves the variant for a color + size pair; without a color option the size alone decides
// @ts-ignore
const getVariant = (product, color, size) => {
  if (!product) return null;

  // A bundle assigned to this color (custom.product_bundles) is what goes into the cart
  const colorBundle = getColorBundle(product, color);
  if (colorBundle) {
    return (
      // @ts-ignore
      colorBundle.variants.find((v) => v.size === null || v.size === size) ||
      null
    );
  }

  if (product.colorOptionIndex === null) {
    // @ts-ignore
    const sizeEntry = product.sizes.find((s) => s.value === size);
    return sizeEntry
      ? { id: sizeEntry.variantId, available: sizeEntry.available }
      : null;
  }

  const candidates = product.variants.filter(
    // @ts-ignore
    (v) =>
      normalizeColor(v.options[product.colorOptionIndex]) ===
        normalizeColor(color) &&
      (product.sizeOptionIndex === null ||
        v.options[product.sizeOptionIndex] === size),
  );
  // Prefer the variant where every non-color option equals this size (bundles with one size option per component)
  return (
    candidates.find(
      // @ts-ignore
      (v) =>
        v.options.every(
          // @ts-ignore
          (option, index) =>
            index === product.colorOptionIndex || option === size,
        ),
    ) ||
    candidates[0] ||
    null
  );
};

// @ts-ignore
const isColorAvailable = (product, color) => {
  const colorBundle = getColorBundle(product, color);
  // @ts-ignore
  if (colorBundle) return colorBundle.variants.some((v) => v.available);

  // Colors shown from the page product (bundle product has no color option) carry their own availability
  if (product.colorOptionIndex === null) {
    // @ts-ignore
    const colorEntry = product.colors.find(
      // @ts-ignore
      (c) => normalizeColor(c.value) === normalizeColor(color),
    );
    return Boolean(colorEntry && colorEntry.available);
  }
  return product.variants.some(
    // @ts-ignore
    (v) =>
      v.available &&
      normalizeColor(v.options[product.colorOptionIndex]) ===
        normalizeColor(color),
  );
};

// @ts-ignore
const getSizesWithAvailability = (product) => {
  const sizes = product ? product.sizes : [];
  // @ts-ignore
  return sizes.map((size) => {
    // @ts-ignore
    const variant = getVariant(product, selectedColor, size.value);
    return {
      value: size.value,
      available: Boolean(variant && variant.available),
    };
  });
};

// @ts-ignore
const getDefaultSize = (product) => {
  const sizes = getSizesWithAvailability(product);
  // @ts-ignore
  return sizes.find((size) => size.available) || sizes[0];
};

// @ts-ignore
const getColorByVariantId = (product, variantId) => {
  if (!product || !variantId) return null;
  return (
    product.colors.find(
      // @ts-ignore
      (color) => (color.variantIds || []).includes(String(variantId)),
    ) || null
  );
};

const getUrlVariantId = () =>
  new URL(window.location.href).searchParams.get("variant");

// The color of the ?variant= in the URL wins, otherwise the color of the product's first variant
// @ts-ignore
const getDefaultColor = (product) => {
  const colors = product ? product.colors : [];
  return (
    getColorByVariantId(product, getUrlVariantId()) ||
    getColorByVariantId(product, product?.firstVariantId) ||
    // @ts-ignore
    colors.find((color) => isColorAvailable(product, color.value)) ||
    colors[0]
  );
};

// Keeps ?variant= in the URL pointing at a variant of the selected color, so a reload restores it
// @ts-ignore
const updateUrlVariant = (color) => {
  // @ts-ignore
  const colorEntry = currentProduct.colors.find(
    // @ts-ignore
    (c) => normalizeColor(c.value) === normalizeColor(color),
  );
  if (!colorEntry || !colorEntry.imageVariantId) return;

  const url = new URL(window.location.href);
  const urlVariantId = url.searchParams.get("variant");
  // Leave the URL alone if it already points at a variant of this color
  if (urlVariantId && (colorEntry.variantIds || []).includes(urlVariantId))
    return;

  url.searchParams.set("variant", colorEntry.imageVariantId);
  window.history.replaceState(window.history.state, "", url.toString());
};

// @ts-ignore
const renderColorButtons = (product) => {
  const colors = product ? product.colors : [];
  // @ts-ignore
  color_buttons_wrapper
    .closest(".color_wrapper")
    .classList.toggle("hidden", colors.length === 0);

  const colorLabel = document.querySelector(".color_wrapper .color-label");
  if (colorLabel)
    colorLabel.textContent = selectedColor
      ? `Color - ${selectedColor}`
      : "Color";

  // @ts-ignore
  color_buttons_wrapper.innerHTML = colors
    .map(
      // @ts-ignore
      (color) => `
        <button
          class="color_button${color.value === selectedColor ? " is-active-color" : ""}${isColorAvailable(product, color.value) ? "" : " is-unavailable"}"
          data-color="${color.value}"
          title="${color.value}"
          aria-label="${color.value}"
        >
          <span class="color_button_swatch" style="--swatch-background: ${color.swatch}"></span>
        </button>
      `,
    )
    .join("");
};

// @ts-ignore
const renderSizeButtons = (product) => {
  const sizes = getSizesWithAvailability(product);
  // @ts-ignore
  size_buttons_wrapper.innerHTML = sizes
    .map(
      // @ts-ignore
      (size) => `
        <button class="size_button${size.value === selectedSize ? " is-active-size" : ""}" data-size="${size.value}"${size.available ? "" : " disabled"}>${size.value}</button>
      `,
    )
    .join("");
};

// Re-renders the media gallery for the chosen color, mirroring how MediaGallery handles a variant update
// @ts-ignore
let galleryAbortController = null;
// @ts-ignore
const updateGalleryForColor = (color) => {
  // @ts-ignore
  const colorEntry = currentProduct.colors.find(
    // @ts-ignore
    (c) => normalizeColor(c.value) === normalizeColor(color),
  );
  if (!colorEntry || !colorEntry.imageVariantId) return;

  const mediaGallery = document.querySelector("media-gallery");
  const section = mediaGallery?.closest(".shopify-section");
  if (!mediaGallery || !section) return;

  const sectionId = section.id.replace("shopify-section-", "");
  const url = new URL(window.location.href);
  url.searchParams.set("variant", colorEntry.imageVariantId);
  url.searchParams.set("section_id", sectionId);

  // @ts-ignore
  galleryAbortController?.abort();
  galleryAbortController = new AbortController();

  fetch(url.toString(), { signal: galleryAbortController.signal })
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const newMediaGallery = html.querySelector("media-gallery");
      const currentMediaGallery = document.querySelector("media-gallery");
      if (newMediaGallery && currentMediaGallery)
        currentMediaGallery.replaceWith(newMediaGallery);
    })
    .catch((error) => {
      if (error.name !== "AbortError") console.error(error);
    });
};

const updateSelectedVariant = () => {
  const variant = getVariant(currentProduct, selectedColor, selectedSize);
  if (variant) setSelectedVariant(variant.id);
};

// @ts-ignore
const getAddToCartForms = () =>
  Array.from(
    document.querySelectorAll(
      `product-form-component[data-product-id="${currentProductId}"] form`,
    ),
  );

// @ts-ignore
const setSelectedVariant = (variantId) => {
  if (!variantId) return;

  getAddToCartForms().forEach((form) => {
    let overrideInput = form.querySelector("[data-bundle-variant-override]");
    if (!overrideInput) {
      overrideInput = document.createElement("input");
      // @ts-ignore
      overrideInput.type = "hidden";
      overrideInput.setAttribute("data-bundle-variant-override", "");
      form.appendChild(overrideInput);
    }
    // @ts-ignore
    overrideInput.value = variantId;

    // Same property the tier selector sets, so the cart line links back to this page
    if (currentProduct?.usesBundleProduct) {
      const sourceUrlName = "properties[_bundle_source_url]";
      let sourceUrlInput = form.querySelector(`input[name="${sourceUrlName}"]`);
      if (!sourceUrlInput) {
        sourceUrlInput = document.createElement("input");
        // @ts-ignore
        sourceUrlInput.type = "hidden";
        // @ts-ignore
        sourceUrlInput.name = sourceUrlName;
        form.appendChild(sourceUrlInput);
      }
      // @ts-ignore
      sourceUrlInput.value = `${window.location.pathname}${window.location.search}`;
    }
  });
};

type_buttons.forEach((button) => {
  button.addEventListener("click", () => {
    // Only dynamic types navigate here; the build your bundle link handles itself
    // @ts-ignore
    if (!button.dataset.type) return;
    // @ts-ignore
    const firstProductOfType = getProductsByType(button.dataset.type)[0];
    if (firstProductOfType) window.location.href = firstProductOfType.url;
  });
});

// @ts-ignore
style_buttons_wrapper.addEventListener("click", (event) => {
  // @ts-ignore
  const styleButton = event.target.closest(".style_button");
  if (!styleButton) return;

  const selectedProduct = selected_products.find(
    // @ts-ignore
    (p) => String(p.id) === styleButton.dataset.productId,
  );
  if (selectedProduct) window.location.href = selectedProduct.url;
});

// @ts-ignore
size_buttons_wrapper.addEventListener("click", (event) => {
  // @ts-ignore
  const sizeButton = event.target.closest(".size_button");
  if (!sizeButton) return;

  // @ts-ignore
  size_buttons_wrapper.querySelectorAll(".size_button").forEach((b) => {
    b.classList.remove("is-active-size");
  });
  sizeButton.classList.add("is-active-size");
  selectedSize = sizeButton.dataset.size;
  updateSelectedVariant();
});

// @ts-ignore
color_buttons_wrapper.addEventListener("click", (event) => {
  // @ts-ignore
  const colorButton = event.target.closest(".color_button");
  if (!colorButton) return;

  selectedColor = colorButton.dataset.color;
  renderColorButtons(currentProduct);

  // Keep the chosen size if it exists in the new color, otherwise fall back to the first available one
  const sizes = getSizesWithAvailability(currentProduct);
  // @ts-ignore
  const currentSize = sizes.find((size) => size.value === selectedSize);
  if (!currentSize || !currentSize.available) {
    const defaultSize = getDefaultSize(currentProduct);
    selectedSize = defaultSize ? defaultSize.value : null;
  }
  renderSizeButtons(currentProduct);
  updateSelectedVariant();
  updateUrlVariant(selectedColor);
  updateGalleryForColor(selectedColor);
});

// The pre-set bundle is selected by default and lists every product of this template, even if the page product is not among them
if (allTypesButton) {
  selectType(allTypesButton);
  renderStyleButtons(selected_products);
}

if (currentProduct) {
  if (!allTypesButton) {
    const currentTypeButton = Array.from(type_buttons).find(
      // @ts-ignore
      (b) => b.dataset.type === currentProduct.type,
    );
    if (currentTypeButton) selectType(currentTypeButton);
    renderStyleButtons(getProductsByType(currentProduct.type));
  }
  selectStyle(currentProduct.id);

  const defaultColor = getDefaultColor(currentProduct);
  selectedColor = defaultColor ? defaultColor.value : null;
  renderColorButtons(currentProduct);
  if (selectedColor) {
    updateUrlVariant(selectedColor);
    // Without ?variant= the gallery was rendered for the first available variant, which may be another color
    if (
      defaultColor &&
      !(defaultColor.variantIds || []).includes(
        String(currentProduct.renderedVariantId),
      )
    )
      updateGalleryForColor(selectedColor);
  }

  const defaultSize = getDefaultSize(currentProduct);
  selectedSize = defaultSize ? defaultSize.value : null;
  renderSizeButtons(currentProduct);

  updateSelectedVariant();
}
